import styled from "styled-components";
import menuClose from "../../assets/images/menu-close.svg";
import menuOpen from "../../assets/images/menu-open.svg";

export const MenuIcons = styled.div`
  background-image: url(${({ isActive }) => (isActive ? menuClose : menuOpen)});
  cursor: pointer;
  height: 22px;
  margin-left: 20px;
  position: absolute;
  top: 28px;
  width: 30px;
  z-index: 140;
`;
